module.exports = __webpack_public_path__ + "img/desjardin.eeea276a.png";